import axiosInstance from '@/store/axios'
import { rejectError } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    distributions ({ commit }, params) {
      return axiosInstance.get('/api/v1/distributions', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    distributionPackages ({ commit }, params) {
      return axiosInstance.get('/api/v1/distribution-packages', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    distributionPackagesStat ({ commit }, params) {
      return axiosInstance.get('/api/v1/distribution-packages/stat', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    distributionPackagesChannelMetaUpdate ({ commit }, data) {
      return axiosInstance({
        method: 'POST',
        url: `/api/v1/distribution-packages/${data.id}/bulk-update`,
        data: data.channels,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    distributionPackageChannels ({ commit }, id) {
      return axiosInstance.get(`/api/v1/distribution-packages/${id}/channels`)
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getdistributionPackageChannels ({ commit }, id) {
      return axiosInstance.get(`/api/v1/distribution-packages/${id}/channels`)
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    setDistributionPackageChannels ({ dispatch }, data) {
      return axiosInstance({
        method: 'POST',
        url: `/api/v1/distribution-packages/${data.id}/set-channels`,
        data: data,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    patchDistributionPackage ({ dispatch }, data) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/distribution-packages/${data.id}`,
        data: data,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    setDistributionVastId ({ commit }, params) {
      return axiosInstance.get(`/api/v1/distribution-packages/${params.id}/set-vast-id`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    setDistributionPreroll ({ commit }, params) {
      return axiosInstance.get(`/api/v1/distribution-packages/${params.id}/set-preroll`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    exportDistributionPackage ({ commit }, id) {
      return axiosInstance.get(`/api/v1/distribution-report?client_id=${id}`, { responseType: 'blob' })
        .then((result) => result)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    exportAllDistributions ({ commit }) {
      return axiosInstance.get('/api/v1/distributions-report', { responseType: 'blob' })
        .then((result) => result)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    createDistributionPackage ({ dispatch }, pack) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/distribution-packages',
        data: pack,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    deleteDistributionPackage ({ commit }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/v1/distribution-packages/${id}`,
      })
        .then((result) => result.data)
        .catch((error) => rejectError(error))
    },
   },
}
